import { gql } from '@apollo/client';

export const GET_LATEST_DELIVERY_NUMBERS = gql`
    query GetLatestDeliveryNumbers {
        getLatestDeliveryNumbers
    }
`;
